import {
	type ActivityListItemResponseDTO,
	DashboardEventType,
	type TaskListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export type ActivityOrTaskListItem =
	| ActivityListItemResponseDTO
	| TaskListItemResponseDTO;

export const isActivityListItem = (
	item: ActivityOrTaskListItem,
): item is ActivityListItemResponseDTO =>
	item.discriminator === DashboardEventType.Activity;
